import type { ReactNode } from 'react';

/** SEO head content is already present in prerendered public HTML. */
export function HelmetProvider({ children }: { children: ReactNode }) {
  return children;
}

export function Helmet() {
  return null;
}
